import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import VueHighcharts from 'vue3-highcharts';
import { MoleculeCardSimple } from '@/components/molecules';

// Definindo as props para receber os dados dinamicamente

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganismsDetailChart',
  props: {
  data: {
    type: Array,
    required: true,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  pointStart: {
    type: Number,
    default: Date.UTC(2023, 11, 1, 0, 0), // Valor padrão (pode ser ajustado)
  },
  pointInterval: {
    type: Number,
    default: 3600 * 1000, // Intervalo padrão de 1 hora
  },
},
  emits: ['clickIconTitle'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

// Definindo a variável chartOptions que será atualizada dinamicamente
const chartOptions = ref<any>({
  chart: {
    type: 'areaspline',
    height: '350px',
    backgroundColor: 'transparent',
  },
  title: {
    text: '', // Usando o título da prop
  },
  plotOptions: {
    series: {
      pointStart: props.pointStart, // Usando o ponto de início da prop
      pointInterval: props.pointInterval, // Usando o intervalo de ponto da prop
    },
    areaspline: {
      color: '#FF5C00',
      fillColor: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, '#FF5C0020'],
          [1, '#FF5C0000'],
        ],
      },
      threshold: null,
      marker: {
        lineWidth: 1,
        lineColor: null,
        fillColor: 'white',
      },
    },
  },
  yAxis: {
    min: 0,
    max: 60,
    title: {
      text: '',
    },
    labels: {
      style: {
        color: 'var(--color-title)',
      },
      format: '{value} ms', // Exibir valores em "ms"
    },
    tickInterval: 5, // Intervalo de 5 ms
  },
  xAxis: {
    type: 'datetime',
    tickInterval: 3600 * 1000, // Intervalo de 1 hora
    labels: {
      style: {
        color: 'var(--color-title)',
      },
      format: '{value:%H:%M}h', // Exibir no formato "HH:mmh"
    },
  },
  legend: {
    itemStyle: {
      color: 'var(--color-title)', // Cor dos itens da legenda
    },
    gridLineColor: 'rgba(0, 0, 0, 0.1)', // Personalização visual do eixo
  },
  tooltip: {
    formatter: function () {
      return `${this.y} ms`;
    },
  },
  // Usando a prop data para criar múltiplas séries
  series: props.data,
});

// Assinando para reatividade dos dados passados via props
watch(
  () => props.data,
  (newData) => {
    chartOptions.value.series = newData; // Atualiza as séries dinamicamente
  },
);

const __returned__ = { props, emit, chartOptions, get VueHighcharts() { return VueHighcharts }, get MoleculeCardSimple() { return MoleculeCardSimple } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})